import React, { useState } from 'react';

import { Box } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';

interface LongTextNewProps {
  content: string;
  limit: number;
}

const LongTextNew: React.FC<LongTextNewProps> = ({ content, limit }) => {
  const [showAll, setShowAll] = useState(false);

  const handleOnPress = () => {
    setShowAll((prevShowAll) => !prevShowAll);
  };

  const label = showAll ? 'Read less' : 'Read more';

  if (content?.length <= limit) {
    return <Text className="text-body-md text-od-content-secondary">{content}</Text>;
  }

  return (
    <Text className="text-body-md text-od-content-secondary">
      {showAll ? content : content.substring(0, limit) + '...'}{' '}
      <Box
        onClick={handleOnPress}
        aria-label={label}
        analyticsName="cosmos-long-text-read"
        className="inline cursor-pointer text-body-sm text-od-content-primary underline"
      >
        {label}
      </Box>
    </Text>
  );
};

export default LongTextNew;
